import React from "react";
import { SiteNav } from "../components/site/SiteNav";
import { Hero } from "../components/site/Hero";
import { PartnerMarquee } from "../components/site/PartnerMarquee";
import { AboutSection } from "../components/site/AboutSection";
import { TeamsSection } from "../components/site/TeamsSection";
import { MentorsSection } from "../components/site/MentorsSection";
import { ProgramSection } from "../components/site/ProgramSection";
import { PrizesSection } from "../components/site/PrizesSection";
import { LiveSection } from "../components/site/LiveSection";
import { SiteFooter } from "../components/site/SiteFooter";
export function Home() {
  return <div className="w-full bg-sun text-ink" data-id="element-900" data-mp="29ihpvraaofmv">
      <SiteNav data-id="element-901" data-mp="2dhyukihwd8qz" />
      <main data-id="element-902" data-mp="2dii1z59x8eqr">
        <Hero data-id="element-903" data-mp="2dj1m8sn1nf7y" />
        <PartnerMarquee data-id="element-904" data-mp="2dfm57k9t7w3w" />
        <AboutSection data-id="element-905" data-mp="3kvk4whwqwx4x" />
        <TeamsSection data-id="element-906" data-mp="3kw21xgr8ffdw" />
        <MentorsSection data-id="element-907" data-mp="3kuqu95uo1nhi" />
        <ProgramSection data-id="element-908" data-mp="3kxmtqym5wk82" />
        <PrizesSection data-id="element-909" data-mp="3owlyoj7w8gzi" />
        <LiveSection data-id="element-910" data-mp="3ovucu043lxmf" />
      </main>
      <SiteFooter data-id="element-911" data-mp="3oyyn9f85pplj" />
    </div>;
}